import React, { useState } from 'react'
import UserHero from '../../userPages/partials/UserHero'
import ListGroup from '../../userPages/partials/ListGroup'
import { Link, useNavigate } from 'react-router-dom'
import { FaForward } from 'react-icons/fa'
import UserAccount from '../../userPages/partials/UserAccount'
import FormValidation from '../../validators/Formvalidators'
import imgageValidation from "../../validators/Imagevalidators"
import toast from 'react-hot-toast'

export default function CreateTestimonils () {
    let [data, setData] = useState({
        name:"",
        pic:"",
        message:""
    })
    let [getData,setGetData]= useState()
   let navigate = useNavigate()
    let [show, setShow]=useState(false)
    let [errorMessage, setErrorMessage]=useState({
      name:"Name Field Is Required",
      pic:"Pic Field Is Required",
      message:"Messages Field Is Required"
    })
  const getInputData=(e)=>{
    let name= e.target.name;
    let value =e.target.files? e.target.files[0]:e.target.value;
    if(name ==="name" || name==="pic" || name==="profile" || name === "message"){
     setErrorMessage((old)=>{
      return{
        ...old,
       [name]:e.target.files ?imgageValidation(e):FormValidation(e)
      }
     })
     setData((old)=>{
      return{
        ...old,
        [name]:value
      }
     })
    //  (data);
  }
}

  async function postData(e){
    e.preventDefault()
    let error = Object.values(errorMessage).find((x)=>x?.length > 0)
    if(error){
      setShow(true)
    }
    else{
      let response = await fetch("http://34.228.14.188:8000/api/testimonial",{
        method:"GET",
        headers:{
          "content-type":"application/json"
        }
      })
      response = await response.json()
      if(response.result ==="Done"){
        setGetData(response.data)
        // (response.data);
        
        let item = Array.isArray(getData) ? getData.find((x)=> x.name.toLowerCase()===data.name.toLowerCase()  ):null
        // (item);
        
        if(item){
          setErrorMessage((old)=>{
            return{
              ...old,
              'name':"Name is Already Exits "
            }
          })
        }
        else{

           let formData = new FormData()
           formData.append("name", data.name)
           formData.append("pic", data.pic)
           formData.append("message", data.message)

          let response = await fetch ("http://34.228.14.188:8000/api/testimonial",{
            method:"POST",
            body: formData
          })
          response = await response.json()
          // (response);
          
          if(response.result === "Done")
           {
            toast.success("Create SuccessFully !")
            navigate("/admin/testimonial")
           }
          else
           alert("something went wrong")
        }
       
      }

      else{
        // (response);
        
      }
     
    }

  }

  return (
   <>
   <UserHero/>

   <div className="container">
           <div className="container-fluid mt-3">
            <UserAccount/>
               <div className="row">
               <ListGroup/>
                  <div className="col-md-8">
                  <div className="admin-heading">
                  <h3>CREATE TESTIMONIAL <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>:
                           
                       </div>
                     <form  onSubmit={postData}>
                     <div className="mb-3 mt-3 ">
                        <label for="exampleFormControlInput1"  className="form-label">Name*</label>
                        <input type="text" name='name' onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Name"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.name}</p>:""}
                      </div>
                      <div className="mb-3">
                        <label for="exampleFormControlInput1" className="form-label">Pic*</label>
                        <input type="file" name='pic' onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Email"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.pic}</p>:""}
                        
                      </div>
                 
                       <div className="mb-3">
                         <label for="exampleFormControlTextarea1"  className="form-label">Review*</label>
                         <textarea name='message' onChange={getInputData}  className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder='Write the Review....'></textarea>
                         {show && errorMessage ? <p className='text-danger'>{errorMessage.message}</p>:""}
                       
                       </div>
                       <div className="admmin-update mb-5">
                           <button className='w-100 btn-primary' type='submit'>CREATE TESTIMONIAL</button>
                       </div>
                     </form> 
                  </div>
               </div>
           </div>
          </div>
   </>
  )
}
